export default __webpack_public_path__ + "static/media/estate_guide_2.85d11882.webp";